export default {
	data() {
		return {
			entity: {
				id_remote: null,
				id_services: null,
				id_packages: null,
				id_content_sources: null,
				content_source_settings: {},
			},
			updateFields: [
				'id_content_sources',
				'id_packages',
				'id_services',
				'lock',
				'name',
				'services_nonlinear_settings',
				'changed_services_nonlinear_settings',
				'content_source_settings',
				'weight',
				'id_remote',
				'use_drm',
			]
		}
	},
	computed: {
		nonLinearOptions() {
			return [
				{id: null, text: this.$gettext('Neurčeno')},
				{id: true, text: this.$gettext('Ano')},
				{id: false, text: this.$gettext('Ne')},
			]
		},
	},
	methods: {
		getEntity() {
			this.setLoadingMessage()
			return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
				.then(data => {
					this.emptyMessage()
					this.entity = data[this.entityName]
					this._afterGetEntityActions(data)
				})
				.catch(function (error) {
					this.setErrorMessage(error['error_message'])
				}.bind(this))
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/views/channels/mixins/channels.js